<body class="ltr main-body leftmenu">
	<form autocomplete="off" class="p-0" [formGroup]="courseForm" novalidate>
		<div class="main-content side-content pt-0 ml-0">
			<div class="main-container container-fluid">
				<div class="inner-body" [formGroup]="courseForm">
					<div class="row row-sm add-form">
						<!-- <form autocomplete="off" class="p-0" [formGroup]="courseForm" novalidate> -->
						<div class="col-lg-12 col-md-12">
							<div class="card custom-card">
								<div class="card-body">
									<div class="row">
										<div class="col-md-9">
											<div class=" d-flex align-items-center pl-3">
												<img alt="Logo" src="../../assets/img/CollegeMaster.png"
													class="mh-45px pb-2">
												<div class="ml-2">
													<h3 class="main-content-label mb-1"><b>
															{{'header.college-mapping.table.CollegeMapping' | translate}}
														</b></h3>
													<p class="text-muted card-sub-title mb-0">
														{{'header.college-mapping.table.CollegeMappingRecord' | translate}}
													</p>
												</div>
											</div>
										</div>
										<!-- <div class="col-md-3" [formGroup]="courseForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>{{'header.college-data.titleList.Search' | translate}}
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div> -->

									</div>
									<hr class="mt-2">
									<div class="row mt-3 clearfix">
										<div class="col-sm-4">
											<div class="form-group">
												<div class="">
													<div class="row">
														<div class="col-sm-12">
															<mat-radio-group class="example-full-width"
																aria-label="Select an option" formControlName="radio">
																<div class="row">
																	<div class="col-sm-4 p-1 ml-1 mt-2">
																		<mat-radio-button class="ml-1" value="clg"
																			(change)="clgClick()">{{'header.college-mapping.table.College' | translate}}
																		</mat-radio-button>
																	</div>
																	<div class="col-sm-4 p-1 ml-1 mt-2">
																		<mat-radio-button class="ml-1" value="course"
																			(change)="courseClick()">{{'header.college-mapping.table.Course' | translate}}
																		</mat-radio-button>
																	</div>
																</div>
															</mat-radio-group>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div *ngIf="isShownCollegeDiv==true" class="col-sm-3">
											<div class="form-group">
												<div class="">
													<mat-form-field appearance="outline" class="example-full-width">
														<mat-label>{{'header.college-mapping.table.CollegeName' | translate}}</mat-label>
														<mat-select [disabled]=" isCourseRadioBtn" #select23
															placeholder="CoCode" class="colorblack"
															formControlName="college">
															<mat-select-filter *ngIf="select23.focused"
																[placeholder]="'Filter'" [displayMember]="'CgName'"
																[array]="collegeList"
																(filteredReturn)="filteredCollegeList =$event">
															</mat-select-filter>
															<mat-option *ngFor="let item of filteredCollegeList"
																[value]="item.CgCode"
																(click)="oneClgClick(item.CgCode,'')">{{item.CgCode}} -
																{{item.CgName}}
															</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>
										</div>
										<div *ngIf="isShownCourseDiv==true" class="col-sm-3">
											<div class="form-group">
												<div class="">
													<mat-form-field appearance="outline" class="example-full-width">
														<mat-label>{{'header.college-mapping.table.CourseName' | translate}}</mat-label>
														<mat-select [disabled]="isCollegeRadioBtn" #select22
															placeholder="CoCode" class="colorblack"
															formControlName="course">
															<mat-select-filter *ngIf="select22.focused"
																[placeholder]="'Filter'" [displayMember]="'CoName'"
																[array]="courseList"
																(filteredReturn)="filteredCourseList =$event">
															</mat-select-filter>
															<mat-option *ngFor="let item of filteredCourseList"
																[value]="item.CoCode"
																(click)="oneCourseClick(item.CoCode,'')">{{item.CoCode}}
																- {{item.CoName}}
															</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>
										</div>
										<!-- <div class="col-sm-2 offset-sm-1">
												
											</div> -->
										<div class="col-sm-4 ml">
											<!-- First button -->
											<span *ngIf="submitcourse && ColgMapCreate" class="floatright mt-1">
												<button id="Save" type="button" class="btn btn-primary btn-icon-text"
													(click)="submit()">
													<span style="display: contents; align-items: center;">
														<img width="20vh" src="../../assets/img/save.gif">
														{{'header.college-mapping.table.Save' | translate}}
													</span>
												</button>
											</span>

											<!-- Second button -->
											<span *ngIf="submitcollege && ColgMapCreate" class="floatright mt-1">
												<button id="Save2" type="button" class="btn btn-primary btn-icon-text"
													(click)="submit1()">
													<span style="display: contents; align-items: center;">
														<img width="20vh" class="p-0" src="../../assets/img/save.gif">
														{{'header.college-mapping.table.Save' | translate}}
													</span>
												</button>
											</span>
											<span *ngIf="reset" class="floatright mt-1 mr-3">
												<button id="Back" type="button" class="btn btn-primary btn-icon-text"
													(click)="back()">
													<span style="display: contents; align-items: center;">
														<img width="20vh" src="../../assets/img/turn-left.gif">
														{{'header.college-mapping.table.Back' | translate}}
													</span>
												</button>
											</span>
											<span *ngIf="reset" class="floatright mt-1 mr-3">
												<button id="Print" type="button"
													class="btn sz btn-primary btn-icon-text floatright mt-1 fr"
													(click)="Print()">
													<span style="display: contents; align-items: center;">
														<img width="20vh" src="../../assets/img/printer.gif"
															style="margin-right: 7px;">
														{{'header.college-mapping.table.Print' | translate}}
													</span>
												</button>
											</span>

										</div>
									</div>
									<hr class="mt-1">
									<div *ngIf="isShownCollegeList==true" class="row">
										<div class="col-sm-8">
											<div class=" d-flex align-items-center pl-3 mb-3">
												<img alt="Logo" src="../../assets/img/CollegeMaster.png"
													class="mh-40px pb-2">
												<div class="ml-2">
													<h3 class="main-content-label mb-1"><b>
															College
														</b></h3>
													<p class="text-muted card-sub-title mb-0">
														{{'header.college-mapping.table.ClgList' | translate}}
													</p>
												</div>
											</div>

										</div>
										<div class="col-sm-4 ">
											<mat-form-field appearance="outline" class="example-full-width">
												<mat-label>{{'header.college-mapping.table.Search' | translate}}
												</mat-label> <input type="text" class="color" matInput
													placeholder="Search" (input)="applyFilter($event)">
												<mat-icon matSuffix>search</mat-icon>
											</mat-form-field>
										</div>
										<div class="table-responsive table-container">
											<table appShortTable id="datatable" class="table table-bordered text-nowrap">
												<thead>
													<tr>
														<th class="f600 text-center " width="5%"> {{'header.college-mapping.table.Action' | translate}}
														</th>
														<th class="f600 " width="90%">{{'header.college-mapping.table.CollegeName' | translate}}</th>
													</tr>
												</thead>
												<tbody id="table_data" formArrayName="CollegeArr">
													<tr *ngFor="let college of getControls(); let i = index"
														[formGroupName]="i">
														<td class="text-center ">
															<mat-checkbox id="{{college.value.CgCode}}"
																formControlName="clgcoursecheckbox">
															</mat-checkbox>
														</td>
														<td>{{college.value.CgCode}} - {{college.value.CoCgCgCode}} </td>
													</tr>
												</tbody>
											</table>
										</div>
										<div class="col-sm-4 offset-sm-8 pt-2 pr-0">
											<!-- <mat-paginator [length]="totalItems" [pageSize]="pageSize"
			  [pageSizeOptions]="pageSizeOptions"
			  (page)="onPageChange($event)"></mat-paginator> -->
										</div>
									</div>
									<div *ngIf="isShownCourseList==true" class="row">
										<div class="col-sm-8 ">
											<div class=" d-flex align-items-center pl-3 mb-3">
												<img alt="Logo" src="../../assets/img/CourseMaster.png"
													class="mh-40px pb-2">
												<div class="ml-2">
													<h3 class="main-content-label mb-1"><b>
															Course
														</b></h3>
													<p class="text-muted card-sub-title mb-0">
													{{'header.college-mapping.table.Courselist' | translate}}
													</p> 
												</div>
											</div>
										</div>
										<div class="col-sm-4 ">
											<mat-form-field appearance="outline" class="example-full-width">
												<mat-label>{{'header.college-mapping.table.Search' | translate}}
												</mat-label> <input type="text" class="color" matInput
													placeholder="Search" (input)="applyFilter($event)">
												<mat-icon matSuffix>search</mat-icon>
											</mat-form-field>
										</div>
										<div class="table-responsive table-container" formArrayName="CourseArr">
											<table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
												<thead>
													<tr>
														<th class="f600 text-center" width="5%">{{'header.college-mapping.table.Action' | translate}}
														</th>
														<th class="f600 text-left" width="90%">{{'header.college-mapping.table.CourseName' | translate}} </th>
													</tr>
												</thead>
												<tbody id="table_data">
													<tr *ngFor="let course of getControls1(); let i = index "
														[formGroupName]="i">
														<td class="text-center">
															<mat-checkbox id="{{course.value.CoCgCoCode}}"
																[formControl]="course.get('clgcoursecheckbox')">
															</mat-checkbox>
														</td>
														<td class="text-left"> {{ course.get('CoCgCoCode').value }}
														</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div class="col-sm-4 offset-sm-8 pt-2 pr-0">
											<!-- <mat-paginator [length]="totalItems" [pageSize]="pageSize"
											  [pageSizeOptions]="pageSizeOptions"
											  (page)="onPageChange($event)"></mat-paginator> -->
										</div>
									</div>
								</div>

							</div>
						</div>
						<!-- </form> -->
					</div>

				</div>
			</div>
		</div>
	</form>
</body>